import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Send } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { contactInfo } from '../utils/mockData';

export const FloatingContact = () => {
  const { t } = useLanguage();
  return (
    <>
    <div data-testid="floating-contact-spacer" className="md:hidden h-20 bg-gray-50 dark:bg-black" />
    <div
      data-testid="floating-contact-bar"
      className="md:hidden fixed bottom-0 inset-x-0 z-40 flex gap-2 p-3 bg-white/90 dark:bg-black/90 backdrop-blur-md border-t border-gray-200 dark:border-gray-800"
    >
      <Link
        to="/kontakt"
        data-testid="floating-inquiry-btn"
        className="flex-1 flex items-center justify-center gap-2 bg-green-600 active:bg-green-700 text-white font-semibold py-3 rounded-lg shadow-lg transition-colors duration-200"
      >
        <Send size={18} />
        <span>{t('floating.inquiry')}</span>
      </Link>
      <a
        href={`tel:${contactInfo.phone.replace(/\s/g, '')}`}
        data-testid="floating-call-btn"
        className="flex items-center justify-center gap-2 px-5 bg-gray-900 dark:bg-white text-white dark:text-black font-semibold py-3 rounded-lg shadow-lg"
      >
        <Phone size={18} />
        <span>{t('floating.call')}</span>
      </a>
    </div>
    </>
  );
};
